module.exports = __webpack_public_path__ + "static/media/Policy_Leaves.9572491f.pdf";